import { CaseStudy } from '../../types';
import { VAMOSLY_HERO } from '../../assets/images';

export const vamosly: CaseStudy = {
  id: '14',
  title: 'Vamosly',
  category: 'Padel Tournaments & Leagues',
  imageUrl: VAMOSLY_HERO,
  description: 'The ultimate padel tournament and league platform. Vamosly helps clubs, organizers, and players run flawless padel sessions with Americano, Mexicano, and Standard Doubles formats — automatically paired, fairly rotated, and live scored.',
  screenshots: [
    'https://images.unsplash.com/photo-1622163642998-1ea32b0bbc67?q=80&w=800&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1554068865-24cecd4e34d8?q=80&w=800&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1595435934249-5df7ed86e1c0?q=80&w=800&auto=format&fit=crop'
  ],
  hasPrivacyPolicy: true,
  hasTermsAndConditions: true,
  hasAccountDeletion: true
};
